import { useState } from 'react';
import { useCreateSelectionList, useUpdateSelectionList, useSelectedPlant } from '../../../../hooks';

import { SetupDrawer } from '../../../atoms';
import { TextInput } from '@pella/sash-framework';

/**
 * Component for the Selection List Drawer.
 * @param {Local.SetupDrawerProps} props - Component props
 */
export const SelectionListDrawer = ({ open, close, data, selectedId }) => {
  const { selectedPlant } = useSelectedPlant();
  const { mutate: createSelectionList, isPending: isCreating } = useCreateSelectionList();
  const { mutate: updateSelectionList, isPending: isUpdating } = useUpdateSelectionList();

  const [formChanges, setFormChanges] = useState(
    /** @type {Partial<Pella.ProductionRequestAPI.CreateSelectionListInput>} */ ({}),
  );

  const currentForm = selectedId ? data?.find((record) => record.id === selectedId) : { active: true };

  // Combine initial data with form changes to get the current selection list state
  const selectionList = { ...currentForm, ...formChanges };
  const isEdit = Boolean(selectedId);

  /** Handler to reset form and close drawer */
  const handleClose = () => {
    setFormChanges({});
    close();
  };

  /** handler for form submission */
  const handleSubmit = () => {
    // Ensure all required fields are defined before mutation
    if (!isEdit) {
      const input = {
        plantId: selectedPlant,
        /* v8 ignore start */
        description: selectionList.description || '',
        /* v8 ignore stop */
      };
      createSelectionList(input, { onSuccess: handleClose });
    } else {
      const id = selectedId;
      const input = {
        description: selectionList.description,
      };
      updateSelectionList({ id, input }, { onSuccess: handleClose });
    }
  };

  const hasRequiredFields = Boolean(selectionList.description?.trim());
  const isLoading = isCreating || isUpdating;

  const disableSubmit = !hasRequiredFields || isLoading;

  return (
    <SetupDrawer
      open={open}
      close={handleClose}
      title='Selection List'
      isEdit={isEdit}
      isCopy={false}
      onSubmit={handleSubmit}
      disableSubmit={disableSubmit}
    >
      <TextInput
        id='selectionListNameInput'
        labelText='Selection List Name'
        maxLength={50}
        required={Boolean(!selectionList.description)}
        value={selectionList.description || ''}
        onChange={(e) => setFormChanges((prev) => ({ ...prev, description: e.target.value }))}
      />
    </SetupDrawer>
  );
};
